import React from 'react';
import PropTypes from 'prop-types';

import cypressIds from 'Components/cypress_ids.json';
import { applyCypressData } from 'Utilities/helpers';

import SaleTime from '../SaleTime/SaleTime';
import VehicleListTabs from '../VehicleListTabs/VehicleListTabs';

import styles from '../VehicleList.module.scss';

const VehiclesListBase = ({ children }) => (
	<div className={styles.container} {...applyCypressData(cypressIds.containers.vehicle)}>
		<div className={styles.vehicleListTitle}>
			<section>
				<SaleTime />
				<VehicleListTabs />
			</section>
		</div>
		{children}
	</div>
);

VehiclesListBase.defaultProps = {
	isInitialLoad: true,
};

VehiclesListBase.propTypes = {
	children: PropTypes.node.isRequired,
	isInitialLoad: PropTypes.bool,
};

export default VehiclesListBase;
